<template>
  <div></div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'BootstrapPage',
  computed: {
    ...mapState([
      'appReady',
      'userObject'
    ])
  },
  created () {
    this.$store.commit('UPDATE_APP_STEP', 1)
  },
  watch: {
    appReady (appReady) {
      if (appReady) {
        this.$router.push(this.userObject ? '/home' : '/start')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/BootstrapPage.vue